/** @jsxRuntime classic */
/** @jsx jsx */
import {css, jsx} from "@emotion/core";
import React, {RefObject} from 'react';
import {Button, Dialog, TextInput, Toolbar, ToolbarSpacer} from "@ice/components";
import {getAppComponent} from "../store/Accessor";
import {$t} from "../lang/LangUtil";
import {FormContainer} from "./FormContainer";


interface EditTextDialogProps {
    title: string;
    value: string;
    confirmText: string;
    onChange: (value: string) => void;
}


interface EditTextDialogState {
    value: string;
}


export class EditTextDialog extends React.Component<EditTextDialogProps, EditTextDialogState> {

    private textFieldRef: RefObject<HTMLInputElement> = React.createRef<HTMLInputElement>();

    constructor(props: EditTextDialogProps) {
        super(props);
        this.state = {
            value: this.props.value
        }
    }


    componentDidMount() {
        if (this.textFieldRef.current) {
            this.textFieldRef.current.focus();
            this.textFieldRef.current.select();
        }
    }

    private close = () => {
        getAppComponent().hideDialog();
    }

    private confirm = () => {
        this.props.onChange(this.state.value);
    }

    render = () => {
        return (
            <Dialog
                onClose={this.close}
                title={this.props.title}
                closeControl={true}
                modal={true}
            >
                <div css={css`width: 34rem; overflow: hidden; padding: 1rem`}>
                    <FormContainer>
                        <TextInput
                            ref={this.textFieldRef}
                            defaultValue={this.state.value}
                            onChange={evt => this.setState({value: evt.target.value})}
                            onKeyDown={event => {
                                if (event.key === "Enter") {
                                    this.confirm();
                                }
                            }}
                        />

                        <Toolbar bordered={false}>
                            <ToolbarSpacer />
                            <Button autoFocus onClick={this.close}>{$t("cancel")}</Button>
                            <Button disabled={!this.state.value?.trim()} onClick={this.confirm} intent="primary">
                                {this.props.confirmText}
                            </Button>
                        </Toolbar>
                    </FormContainer>
                </div>
            </Dialog>
        );
    }

}
